import { ChangeDetectionStrategy, Component, computed, Input, OnInit, Signal, signal, WritableSignal } from '@angular/core';
import { ChatUserMsgModel, UserDetailModel } from 'countable@model';

@Component({
  selector: 'app-ai-user-chat-preview',
  templateUrl: './ai-user-chat-preview.component.html',
  styleUrl: './ai-user-chat-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AiUserChatPreviewComponent implements OnInit {

  @Input() set chatPreview(chatPreview: ChatUserMsgModel) {
    if (chatPreview) {
      this.chat.set(chatPreview);
    }
  }

  public userDetails: WritableSignal<UserDetailModel> = signal<UserDetailModel>(null);
  public userName: Signal<string> = computed(() => {
    return this.provideInitials(this.userDetails()?.fullName);
  });
  public chat: WritableSignal<ChatUserMsgModel> = signal<ChatUserMsgModel>(null);
  public hasCopiedText: WritableSignal<boolean> = signal<boolean>(false);

  constructor() {
    this.userDetails.set(JSON.parse((localStorage.getItem('userDetails'))));
  }


  ngOnInit() {

  }

  private provideInitials(name: string = '') {
    if (!name) {
      return '';
    }
    const words = name.trim().split(/\s+/);
    let initials = '';
    for (const word of words) {
      if (word.length > 0) {
        initials += word[0].toUpperCase();
      }
      if (initials.length === 2) {
        break;
      }
    }
    return initials;
  }

  public copyText() {
    this.hasCopiedText.set(true);
    setTimeout(() => this.hasCopiedText.set(false), 5000);
  }

}
